export default "<p>app-center works!</p>\n"